// extracted by mini-css-extract-plugin
module.exports = {"container":"e_RG","icon":"e_SG"};